/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';

import type { IDropdownOptions } from '@/Interfaces/Data';
import Requests from '@/Services/Requests';
import useRequest from '../util/useRequest';
import { useAppDispatch, useAppSelector } from '@/_store/hooks';
import { selectPlacesMinimal } from '@/_store/modules/utils/selectors';
import { setPlacesMinimal } from '@/_store/modules/utils';

export interface IPlaceMinimal {
  nomeExibicao: string;
  cityName: string;
  cityUf: string;
  _id: string;
}

const usePlacesMinimal = () => {
  const dispatch = useAppDispatch();

  const placesMinimal = useAppSelector(selectPlacesMinimal);

  const {
    data: placesMinimalList,
    isLoading,
    error,
    request,
  } = useRequest<IPlaceMinimal[]>();

  useEffect(() => {
    if (isEmpty(placesMinimal) && isEmpty(placesMinimalList)) {
      getPlacesMinimal();

      return;
    }

    if (isEmpty(placesMinimal)) {
      dispatch(
        setPlacesMinimal({
          places: placesMinimalList?.data || [],
        }),
      );
    }
  }, [placesMinimalList]);

  function getPlacesMinimal() {
    request(Requests.places.getPlacesMinimalList());
  }

  const placesMinimalOptions = useMemo(() => {
    const newOptions: IDropdownOptions<string>[] = placesMinimal.map(place => ({
      key: place._id,
      text: `${place.nomeExibicao} - ${place.cityName}/${place.cityUf}`,
      value: place._id,
    }));

    return newOptions;
  }, [placesMinimal]);

  return {
    getPlacesMinimal,
    placesMinimal,
    isLoading,
    error,
    placesMinimalOptions,
  };
};

export default usePlacesMinimal;
